import { PaymentMethodSectionProps, PaymentType } from '../../types';
import { CheckoutSection } from './CheckoutSection';
import { RadioCard } from './RadioCard';

const PAYMENT_TYPE_MAP: Record<PaymentType, { label: string; icon: string }> = {
  ACCOUNT: { label: 'Account', icon: '🏦' },
  CREDIT: { label: 'Credit Card', icon: '💳' },
  ECHECK: { label: 'eCheck', icon: '💵' },
  INVOICE: { label: 'Send Invoice', icon: '📬' },
};

/**
 * Payment method selection section for checkout.
 * Displays available payment types with icons and allows user selection.
 */
export function PaymentMethodSection({
  paymentTypes,
  selectedPaymentType,
  onPaymentTypeChange,
}: PaymentMethodSectionProps) {
  return (
    <CheckoutSection title="Payment Method">
      {paymentTypes.length === 0 && (
        <p className="text-sm text-red-600">
          Your account has no payment methods configured. Please contact your administrator.
        </p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {paymentTypes.map((paymentType) => {
          const paymentInfo = PAYMENT_TYPE_MAP[paymentType] || {
            label: paymentType,
            icon: '💰',
          };

          return (
            <RadioCard
              key={paymentType}
              name="paymentType"
              value={paymentType}
              checked={selectedPaymentType === paymentType}
              onChange={() => onPaymentTypeChange(paymentType)}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="text-2xl mr-3">{paymentInfo.icon}</span>
                  <span className="font-medium text-gray-900">{paymentInfo.label}</span>
                </div>
                {selectedPaymentType === paymentType && (
                  <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </RadioCard>
          );
        })}
      </div>
    </CheckoutSection>
  );
}
